module.exports = __webpack_public_path__ + "static/media/signage-indoor-img15.d538727c.jpg";